import { useParams } from "react-router";

export const useUrl = () => {
  const { workspaceId } = useParams();
  return {
    buildUrl: (path: string) => {
      const newPath = path[0] === "/" ? path.slice(1) : path;
      return [`/w/${workspaceId}`, newPath].join("/");
    },
  };
};
